<template>
    <div class="msp-tabella-records h-mb-2" :class="classComponent" v-if="data">
        <div class='msp-tabella-records-header'>
            <div class='cell' v-for="header in data.headers" :key="header.field" :class="classHeader(header)">{{header.titolo}}</div>
        </div>

        <div v-for="row in filteredRows" :key="row.segmento.id" class='msp-tabella-records-row' :class="{interactive: isInteractive}" @click="selectRow(row)">

            <div class='contents' v-for="(cell, index) in row.cells" :key="index">
                <div v-if="cell.key==='attuali'" class='cell' :class='cell.classeCol +" "+ cell.classeValore'>
                    <div class="arp-coccarda" v-html="renderBest(row, index)"></div>
                    <div class='arp-time'><strong>{{row.segmento.segmentoString}}</strong></div>
                    <strong>{{cell.valore}}</strong>

                    <div v-if="cell.dettaglio" :class=' cell.classeCol + " h-text-nowrap " + cell.classeDettaglio'>{{cell.dettaglio}}</div>
                </div>

                <div v-else class='cell' :style='styleCell(cell, row)' :class='classCell(cell, row)'>
                    <div  class='arp-data'>{{cell.data}}</div>
                    <strong>{{cell.valore}}</strong>

                    <div v-if="cell.dettaglio" :class='cell.classeCol + " " + cell.classeDettaglio'>{{cell.dettaglio}}</div>
                </div>

            </div>
        </div>
        </div>

</template>

<script>
import { configBest } from "@src/js/vue/mixins/record-segmenti.js";
import _recordSegmenti from "@cached/record_segmento.json";
import _record from "@src/js/vue/mixins/record-segmenti.js";
import RP from "@cached/record_periodo.json"

const component = {
    props: {
        "data": {
            type: Object,
        },
        "token": {
            type: String,
        },
        "segmento": {
            type: Number,
        },
    },
  computed: {
      classComponent: function () {
          if (this.segmento) {
              return "singolo";
          } else {
              return "";
          }
      },
      isInteractive: function () {
          return !this.segmento;
      },
      filteredRows: function () {
          if (!this.segmento) {

              return this.data.rows;
          }

          return this.data.rows.filter((r)=>r.segmento.segmento===this.segmento);
      },

        classRiepilogoCp: function () {
            let selected = this.selectRiepilogoCp.options.find(
                (el)=>{
                    return el.id === this.selectRiepilogoCp.selected;
                });
            if (!selected) return "";
            return selected.class;
        },
  },
  data: function() {
    return {
        segmenti: _recordSegmenti,
        selectRiepilogoCp: {
            options: [
                {
                    id: 0,
                    label: 'Best 3 Mesi',
                    class: 'best',
                },
                {
                    id: 1,
                    label: 'Best Anno',
                    class: 'best-anno',
                },
                {
                    id: 2,
                    label: 'Best All Time',
                    class: 'best-all-time',
                },
                {
                    id: 3,
                    label: 'Tutti',
                    class: 'tutti',
                },
            ]
        },
    }
  },
  methods: {
      configBest: function (best) {

          return configBest[best.posizione - 1];
      },

      classCell: function (cell, row) {
          let c = `${cell.classeCol} ${cell.classeValore}`;
          const best = this.getBest(row);

          if (best) {
              const periodo = this.periodoBest(best);
              if (periodo.codice === cell.key) {
                  c += " cell--best";
              }
          }

          return c;
      },

      styleCell: function (cell, row) {
          const best = this.getBest(row);

          const styles = [];

          if (best) {
              const periodo = this.periodoBest(best);
              if (periodo.codice === cell.key) {
                  const config = this.configBest(best);

                  styles.push(`--color-best:${config.color}; --background-best:${config.background}`);

              }
          }

          return styles.join(";");
      },

      selectRow: function (row) {
          this.$emit('select-row', row);
      },
      periodoBest: function (best) {
          const rp = RP.find(el=>el.id == best.rp_id);
          return rp;
      },

      getBest: function (row) {
          if (!(this.data && this.data.bests && this.data.bests.length)) {

              return null;
          }

          return this.data.bests.find(el=>el.rs_id == row.segmento.id);
      },
      renderBest: function (row, index) {
          void(index);
          const best = this.getBest(row);
          if (!best) {
              return "";
          }

          // best all time
          const config = _record.configBest;
          const color = config[best.posizione-1].color;
          const style = `--color: ${color}`;
          return `<i style='${style}' class='icon-best msp-icon-award' />`;
      },

      classHeader: function (header) {
          return `arp-head ${header.classeCol} ${header.classeHead}`;
      },

  },
}
export default component;
</script>

<style lang="scss">
.msp-tabella-records {
    --grid-template-columns:repeat(4,1fr);
    --background-1: #fff;
    --background-2: #fff;
    --background-best: transparent;
    --background-active: #fff;
    --color: #000;
    white-space: nowrap;
    background-color:#fff;
    display: grid;
    gap: 0px 5px;
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr; // Testata e righe
    line-height: 1.2;
    min-width: max-content;
    overflow-x: auto;
    overflow-x: auto; // Consente lo scorrimento condiviso
    overflow-x: hidden; // Impedisce scorrimento esterno al contenitore principale
    padding: 0;
    text-align: left;
    width: 100%;


    .cell {
        background: var(--background);
        color: var(--color);
        padding: 5px 10px;
    }

    .arp-attuale-col {
        display: grid;
        grid-template-rows: repeat(3, auto);
        grid-template-columns: 20px auto;
        grid-template-areas: "coccarda segmento"
        "coccarda risultato"
        "coccarda dettaglio";
        .arp-coccarda {
            grid-area: coccarda;
            align-items: center;
            text-align: center;
        }
        .arp-time {
            grid-area: segmento;
        }
    }


    .msp-tabella-records-header {
        --background: none;
        border: none !important;
        display: grid;
        grid-template-columns: var(--grid-template-columns); // Mantieni le colonne allineate
        grid-template-rows: 1fr;
    }
    .msp-tabella-records-row {
        --background: var(--background-1);
        background:var(--background);
        border-bottom: 1px solid var(--col-grigio-chiaro);
        min-width: max-content;
        text-align: left;
        width: 100%;
        margin: 0;
        font-size: 0.8em;
        padding:0;
        display: grid;
        grid-template-rows: var(--grid-template-rows);
        grid-template-columns: var(--grid-template-columns);
        &:nth-child(even) {
            --background: var(--background-2);
        }

        &.interactive:hover {
            --background: var(--col-msp-chiarissimo);
            --background-active: var(--col-msp-chiarissimo);
        }

    }
    .singolo .msp-tabella-records-row {
        background: #f0f0f0;
    }

    .msp-tabella-records-row {
        .cell {
            &.arp-attuale-col {
                background: var(--background-active);
            }
            &.cell--best {
                background: var(--background-best);
            }
        }
    }

    .icon-best {
        --color: var(--col-grigio-chiaro);
        color: var(--color);
        font-size: 20px;
    }

    .arp-time {
        grid-row: 1;
        grid-column: 1;
        font-size: 1.2em;
    }



    .arp-peso {
        font-style: italic;
        font-size: 0.9em;
    }


    .arp-dettaglio {
        font-weight: normal;
    }

    .contents {
        display: contents;
    }

}
</style>
